export default __webpack_public_path__ + "static/media/024-road work.b9ef5c5c.png";